/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-01 13:36:04
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'

export default {
  getPrice(data) {
    return request.get(`${BASE_URL}/home/index`, data)
  },

  /*获取发票代开*/
  getInvoiceDk(data) {
    return request.get(`${BASE_URL}/invoice_agent/list`, data)
  },

  getInvoiceInfo(data,id) {
    return request.get(`${BASE_URL}/invoice_agent/view/${id}`, data)
  },
  /**
   * @description 获取充值记录
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getRecharge(data) {
    return request.get(`${BASE_URL}/home/recharge`, data)
  },
  /**
   * @description 获取账户信息
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getAccountInfo() {
    return request.get(`${BASE_URL}/home/get_account`)
  },
  /**
   * @description 获取公告内容
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getAnnouncementList(data) {
    return request.post(`${BASE_URL}/home/get_announcement`, data)},
  //设置审核
  setAudit(data,id){
    return request.put(`${BASE_URL}/invoice_agent/audit/${id}`, data)
  },
  getrecharge(){
    return request.get(`${BASE_URL}/home/statistics`)
  }
   /**
   * @description 预充值接口
   * @author RY
   * @date 2021-04-06
   * @returns promise
   */
}